<template>
  <el-dialog class="order-cancel-modal" title="取消订单" :visible.sync="visible" width="400px">
    <div class="content" v-loading="loading">
      <div>
        <div class="title">取消原因：</div>
        <ul>
          <li v-for="item in reasons" @click="current = item" :class="{selected: item === current}" :key="item">{{item}}</li>
        </ul>
        <el-input v-model="other" v-if="current === '其它'" type="textarea" rows="4" placeholder="请输入原因"></el-input>
      </div>
      <div>
        <el-button type="primary" size="small" @click="doCancel">确定取消</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
  import qs from 'qs'
  import ModalMixin from '@/libs/modal/modal-mixin'

  export default {
    mixins: [ModalMixin],
    data () {
      return {
        loading: false,
        order: {},
        current: '',
        other: '',
        reasons: ['老人要求结束', '服务无法继续', '其它']
      }
    },
    methods: {
      init (order) {
        this.order = order
        return this.open()
      },
      doCancel () {
        if (this.current === '其它' && !this.other) {
          this.$message.error('请输入取消原因')
          return
        }
        this.loading = true
        let data = {
          orderGid: this.order.gid,
          result: this.current === '其它' ? this.other : this.current
        }
        this.Service.call('refund', 'POST', qs.stringify({
          orderGid: this.order.gid,
          result: this.current === '其它' ? this.other : this.current
        }), null, null, null, 'application/x-www-form-urlencoded').then(() => {
          this.$message.success('订单取消成功')
          this.close(true)
        }).finally(() => {
          this.loading = false
        })
      }
    }
  }
</script>
